module.exports = __webpack_public_path__ + "static/media/water_adept_robe.b255ee50.png";